//  zhanghuag 2018/3/15
//  说明
// **所有需要调用原生功能都要通过本页面调用

/**
 * guobgf 2021-03-14
 * 更新调用友空间native的方法
 * 之前直接调用友空间方法，导致在不同的平台，方法会不生效或者报错
 * 比如在钉钉上调用友空间native方法会报错导致页面空白
 * 所以在这里统一调用nccmb的方法，在nccmb中判断平台再分发
 *
 * 现在代码中几乎所有native方法都是调的这里
 * 为了业务代码中尽可能少做修改，所以在这里改造
 * 业务代码中也可以直接调用nccmb的native方法
 */

/*import ykjBridge from './ykjbridge.js'
export default ykjBridge*/

import nccmb from "../../../ncc-moible/nccmb";

export default {
    closePage: nccmb.closePage,
    hiddenMenu: nccmb.hiddenMenu,
    showMenu: nccmb.showMenu,
    configNavBar: nccmb.configNavBar,
    selectAttachment: nccmb.selectAttachment,
    share: nccmb.share,
    extendParamFun: nccmb.extendParamFun,
    getAppCode: nccmb.getAppCode,
    getAppInfo: nccmb.getAppInfo,
    openWindow: nccmb.openWindow,
    isShow: nccmb.isShow,
    fileBrowser: nccmb.fileBrowser,
    getSystem: nccmb.getSystem,
    previewFile: nccmb.previewFile,
    openRobot: nccmb.openRobot,
    viewImage: nccmb.viewImage,
    previewImImage: nccmb.previewImImage,
    viewWatch: nccmb.viewWatch,
    backbutton: nccmb.backbutton,
    blockbackbutton: nccmb.blockbackbutton,
    selectContacts: nccmb.selectContacts,
    getLocation: nccmb.getLocation,
    faceRecog: nccmb.faceRecog,
    openChatWindow: nccmb.openChatWindow,
    getUserInformation: nccmb.getUserInformation,
    selectInsideGroup: nccmb.selectInsideGroup,
    setYYStorage: nccmb.setYYStorage,
    getYYStorage: nccmb.getYYStorage,
    removeYYStorage: nccmb.removeYYStorage
}
